import React, { useState } from 'react';
import { Link } from "gatsby";
import CommunityImg from '../../../Common/CommunityImg/CommunityImg';
import { default as image1 } from '../../../../images/eco-product-1.svg';
import { default as image2 } from '../../../../images/eco-product-2.svg';
import './EcoProducts.scss';

const EcoProducts = () => {

  const [selectedTab, setSelectedTab] = useState(1);

  const openLink = link => window.open(link, '_blank', 'noopener');
  return (
    <div className="noissue__eco-alliance__sustainability__container__tabs__eco-products">
      <div className="web">
        <div className="left-section">
          <CommunityImg src={selectedTab === 1 ? image1 : image2} alt="eco product" />
        </div>
        <div className="right-section">
          <div className="tabs">
            <span onClick={() => setSelectedTab(1)} role="presentation" className={`${selectedTab === 1 && 'selected'}`}>Circularity Frameworks</span>
            <span onClick={() => setSelectedTab(2)} role="presentation" className={`${selectedTab === 2 && 'selected'}`}>Supply Chain</span>
          </div>
          {
            selectedTab === 1 &&
            <div className="right-section-content">
              <div className="right-section-content-heading">
                Our journey to circularity is just starting
              </div>
              <div className="right-section-content-subheading">
                We’ve conceptualized each of our products with circularity in mind. Guided by the frameworks of compostable, recycled, and reusable, we ensure each of our products meet at least one of these frameworks. It’s important to us that our products ‘live’ a full life, and are reused as many times as possible, and eventually disposed of in a way that is friendly for the product and environment.
                <br /> <br />
                We’re constantly rethinking how products are conceptualized, rapidly innovating new ways to bring them to market, and we’re just getting started on our circularity journey.
              </div>
              {/* <button className="right-section-content-button" onClick={()=>openLink('https://www.noissue.co/blog/our-circularity-journey/')}>Read More</button> */}
              <Link
                className="right-section-content-button" 
                to="https://noissue.co/blog/our-circularity-journey/"
              >
                Read More
              </Link>
            </div>
          }
          {
            selectedTab === 2 &&
            <div className="right-section-content">
              <div className="right-section-content-heading">
                We're committed to working with suppliers that meet our quality, sustainability and fair treatment standards.
              </div>
              <div className="right-section-content-subheading">
                Our manufacturing and distribution locations are based all over the world. This helps us deliver the best quality products that are customizable (where applicable), at low minimum order quantities. Dependent on the product and quantity of your order, your product will be made and shipped from a location that best allows us to fulfill the order in a timely manner. We have world-class supply and distribution partners that prioritize sustainable materials and fair-trade assurance.
              </div>
              <button className="right-section-content-button" onClick={()=>openLink('https://www.noissue.co/blog/health-safety-wellbeing-supply-chain')}>Read More</button>
            </div>
          }
        </div>
      </div>

      <div className="mobile">
        <div className="tabs">
          <span onClick={() => setSelectedTab(1)} role="presentation" className={`${selectedTab === 1 && 'selected'}`}>Circularity Frameworks</span>
          <span onClick={() => setSelectedTab(2)} role="presentation" className={`${selectedTab === 2 && 'selected'}`}>Supply Chain</span>
        </div>
        <div className="top-section">
          <CommunityImg src={selectedTab === 1 ? image1 : image2} alt="eco product" />
        </div>
        <div className="right-section">
          {
            selectedTab === 1 &&
            <div className="right-section-content">
              <div className="right-section-content-heading">
                Our journey to circularity is just starting
              </div>
              <div className="right-section-content-subheading">
                We’ve conceptualized each of our products with circularity in mind. Guided by the frameworks of compostable, recycled, and reusable, we ensure each of our products meet at least one of these frameworks. It’s important to us that our products ‘live’ a full life, and are reused as many times as possible, and eventually disposed of in a way that is friendly for the product and environment.
                <br /> <br />
                We’re constantly rethinking how products are conceptualized, rapidly innovating new ways to bring them to market, and we’re just getting started on our circularity journey.
              </div>
              <button className="right-section-content-button" onClick={()=>openLink('https://www.noissue.co/blog/our-circularity-journey/')}>Read More</button>
            </div>
          }
          {
            selectedTab === 2 &&
            <div className="right-section-content">
              <div className="right-section-content-heading">
                We're committed to working with suppliers that meet our quality, sustainability and fair treatment standards.
              </div>
              <div className="right-section-content-subheading">
                Our manufacturing and distribution locations are based all over the world. This helps us deliver the best quality products that are customizable (where applicable), at low minimum order quantities. Dependent on the product and quantity of your order, your product will be made and shipped from a location that best allows us to fulfill the order in a timely manner. We have world-class supply and distribution partners that prioritize sustainable materials and fair-trade assurance.
              </div>
              <button className="right-section-content-button" onClick={()=>openLink('https://www.noissue.co/blog/health-safety-wellbeing-supply-chain')}>Read More</button>
            </div>
          }
        </div>
      </div>

    </div>
  )
}

export default EcoProducts;